import { EOtp } from '@/enums/sportEnum'
import { getPkgName } from '@/utils'
import { t } from '@/hooks/system/useVuei18n/t'
import { EMtype } from '@/enums/sport/mtypeEnum'

/** 缓存名前缀 */
export const storePrefixKey = `${getPkgName()}__`

/** 统一格式化时间格式 */
// export const DATE_TIME_FORMAT = isChinese.value ? 'YYYY/MM/DD HH:mm:ss' : 'DD/MM/YYYY HH:mm:ss'
export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss'
/** 币种 */
export const currencyList = {
  1: 'CNY',
  2: 'USD',
  3: 'EUR',
  4: 'GBP',
  5: 'HKD',
  6: 'TWD',
  7: 'MYR',
  8: 'SGD',
  9: 'THB',
  10: 'VND',
  11: 'KRW',
  12: 'JPY',
  13: 'PHP',
  14: 'IDR',
  15: 'INR',
  16: 'AUD',
  17: 'MMK',
  18: 'COP',
  19: 'TZS',
  20: 'NGN',
  21: 'ZMW',
  22: 'BRL',
  23: 'MXN',
  24: 'RUB',
  25: 'EGP',
  26: 'PEN',
  27: 'BOB',
  28: 'PKR',
  29: 'BDT',
  30: 'UGX',
  31: 'ETB',
  32: 'ZAR',
  33: 'HNL',
  34: 'CDF',
  35: 'TRY',
  36: 'IRR',
  37: 'GHS',
  38: 'KES',
  39: 'ILS',
  40: 'CLP',
  41: 'KZT',
  42: 'KGS',
  43: 'TJS',
  44: 'TMT',
  45: 'UZS',
  46: 'LAK',
  47: 'BND',
  48: 'CAD',
  49: 'NZD',
  59: 'PLN',
  60: 'ARS',
  61: 'KHR',
  62: 'NIO',
  63: 'ZWL',
  64: 'IMP',
  65: 'LKR',
  66: 'XOF',
  67: 'NPR',
  68: 'PGK',
  69: 'SAR',
  70: 'AED',
  71: 'KWD',
  72: 'QAR',
  73: 'XAF',
  200: 'USDT',
  201: 'BTC',
  202: 'ETH',
  203: 'LTC',
  204: 'DOGE',
  205: 'BCH',
  206: 'DASH',
  207: 'ETC',
  208: 'BUSD',
  209: 'USDC',
  210: 'XRP',
  1000: 'VNDK',
  1001: 'IDRK',
  1003: 'IRRK',
  1004: 'UZSK',
  1005: 'LAKK',
  1006: 'USDTbc',
  1007: 'KRWK',
  1008: 'KHRK',
  1009: '%TWD',
  1010: '÷TWD',
  1011: 'USD20',
  1200: 'mBTC',
  1201: 'mETH',
  1202: 'mBCH',
  1203: 'mDASH',
  1204: 'mETC',
  1205: 'mLTC',
}

/** 需要金额提示倍率特殊币种 */
export const currencyRatio = {
  1000: {
    ratio: 1000,
    currency: 'VNDK',
    transition: 'VND',
  },
  1001: {
    ratio: 1000,
    currency: 'IDRK',
    transition: 'IDR',
  },
  1003: {
    ratio: 1000,
    currency: 'IRRK',
    transition: 'IRR',
  },
  1004: {
    ratio: 1000,
    currency: 'UZSK',
    transition: 'UZS',
  },
  1005: {
    ratio: 1000,
    currency: 'LAKK',
    transition: 'LAK',
  },
  1007: {
    ratio: 1000,
    currency: 'KRWK',
    transition: 'KRW',
  },
  1008: {
    ratio: 1000,
    currency: 'KHRK',
    transition: 'KHR',
  },
}

/** 订单状态 */
export const orderStatusMap = {
  0: {
    name: t('9585uq'),
    color: '#73A91F',
  },
  1: {
    name: t('k997t7'),
    color: '#ffba00',
  },
  2: {
    name: t('9ibyhi'),
    color: '#d52e21',
  },
  3: {
    name: t('m3wuqr'),
    color: '#d52e21',
  },
  4: {
    name: t('bp3ind'),
    color: '#73A91F',
  },
  5: {
    name: t('fsoxd4'),
    color: '#73A91F',
  },
  101: {
    name: t('bp3ind'),
    color: '#73A91F',
  },
  102: {
    name: t('bp3ind'),
    color: '#73A91F',
  },
}

/** 预约投注状态 */
export const reserveOrderStatusMap = {
  0: {
    name: t('yzqqh6'),
    color: 'var(--el-color-primary)',
  },
  1: {
    name: t('9yd4c7'),
    color: 'var(--text-200)',
  },
  2: {
    name: t('gpvnlr'),
    color: 'var(--text-21)',
  },
  3: {
    name: t('0stnzl'),
    color: 'var(--text-10)',
  },
}

export const handicapMap = {
  [EOtp.EUROPE]: t('idegvg'),
  [EOtp.HONGKONG]: t('pj7gd8'),
  [EOtp.MALAY]: t('qahcj5'),
  [EOtp.INDONESIA]: t('c40ntk'),
  [EOtp.AMERICAN]: t('du7w1e'),
}

/** 订单输赢状态 */
export const orderResultMap = {
  '-1': {
    color: 'var(--text-200)',
    name: t('wktw7j'),
    icon: 'jujue',
  },
  '0': {
    color: 'var(--text-200)',
    name: t('sgb49t'),
    icon: 'quxiao',
  },
  '2': {
    color: 'var(--text-200)',
    name: t('51jxn6idr6k1'),
    icon: 'he',
  },
  '3': {
    color: 'var(--text-200)',
    name: t('f71skk'),
    icon: 'shu',
  },
  '4': {
    color: 'var(--text-22)',
    name: t('mjxyok'),
    icon: 'ying',
  },
  '5': {
    color: 'var(--text-200)',
    name: t('mjxyoe'),
    icon: 'yingban',
  },
  '6': {
    color: 'var(--text-200)',
    name: t('f71skt'),
    icon: 'shuban',
  },
  '7': {
    color: 'var(--text-22)',
    name: t('0stnzl'),
    icon: 'quxiao',
  },
}

// 重新排列想足球波胆展示
export const CORRECT_MARKET_TYPES = [
  1099,
  2012,
  1100,
  1188,
  1192,
  1237,
  1189,
  1190,
  1123,
  5011,
  5006,
  5007,
  20009,
  20010,
  20011,
  20012,
  20013,
  20014,
  20015,
  20016,
  20017,
  20018,
  20019,
  20020,
  20021,
  20022,
  20023,
  20024,
  20025,
  13004,
  13005,
  15004,
  15005,
  47004,
  47005,
  16022,
  16023,
  16024,
  16025,
  51004,
  51005,
  1001006,
  1001010,
  1076,
  1075,
  1077,
  177019,
  177033,
  177020,
  180008,
  180009,
  180010,
  180017,
  180011,
  164014,
  164015,
  164016,
  164017,
  165036,
  165020,
  165019,
  165018,
  179007,
  179008,
  179009,
  179010,
  179029,
  179038,
  179039,
  169007,
  169029,
  169038,
  169039,
  169008,
  169009,
  169010,
]

// 这是提取主客队名称
export const DEFAULT_TOP_TYPE = [
  1127,
  1046,
  1119,
  1120,
  1000,
  1002,
  1005,
  1006,
  1009,
  1011,
  1060,
  1061,
  2001,
  2003,
  2007,
  2012,
  3001,
  3002,
  4001,
  4003,
  4004,
  4008,
  8001,
  8005,
  8006,
  8008,
  51001,
  51002,
  51004,
  51005,
  51006,
  18002,
  19002,
  5002,
  5004,
  5006,
  5007,
  5011,
  13002,
  13004,
  13005,
  15002,
  15004,
  15005,
  47002,
  47004,
  47005,
  6001,
  6002,
  6003,
  6009,
  6010,
  7001,
  7003,
  7006,
  7008,
  // 16003,
  16001,
  78001,
  // 16006,
  // 16014,
  // 16017,
  // 16009,
  20001,
  20005,
  20009,
  20010,
  20011,
  20012,
  20013,
  20014,
  20015,
  20016,
  20017,
  20018,
  20019,
  20020,
  20021,
  20022,
  20023,
  20024,
  20025,
  20026,
  17001,
  17003,
  17004,
  1075,
  1076,
  1077,
  8012,
  47009,
  51008,
  177001,
  177003,
  177013,
  177019,
  177020,
  177033,
  178001,
  178007,
  165002, 165004, 165018, 165019, 165020, 165036, 164002, 164004, 164012, 164014, 164015, 164016, 164017, 180002, 180004, 180008, 180009, 180010, 180011, 180012, 180017,
  179002, 179004, 179007, 179008, 179009, 179010, 179012, 179017, 179019, 179032, 179048,
  169002, 169004, 169007, 169008, 169009, 169010, 169017, 169019, 169032, 169048,
  1194, 1195, 1196, 1197, 1198, 1199, 1200, 1201, 1212, 1215, 1216, 1218, 1219, 1229, 1230, 1231, 1232,

]

export const LINE_ARRY_MARKET_TYPES = [
  5002,
  5004,
  5006,
  5007,
  20009,
  20010,
  20011,
  20012,
  20013,
  20014,
  20015,
  20016,
  20017,
  20018,
  20019,
  20020,
  20021,
  20022,
  20023,
  20024,
  20025,
  20026,
  5011,
  13002,
  13004,
  13005,
  15002,
  15004,
  15005,
  47002,
  47004,
  47005,
  16022,
  16023,
  16024,
  16025,
  51004,
  51005,
  1123,
  1075,
  1076,
  1077,
  180009, 180010, 180011, 180017,
  164015, 164016, 164017, 165020, 165019, 165036,
  179001, 179002, 179004, 179008, 179009, 179010, 179011, 179016, 179018, 179032,
  169001, 169002, 169004, 169008, 169009, 169010, 169011, 169016, 169018, 169032,
]

export const DETAIL_PAGE_MARKET_TYPES = [
  2008,
  1032,
  1018,
  1033,
  2020,
  8010,
  2016,
  177022,
  177024,
  177029,
  // 169037
]

export const LEFT_RIGHT_MARKET_TYPES = [
  1076,
  1075,
  1077,
  164029, 164030, 165030, 165031, 169026, 169027, 179026, 179027,
]

/** 赛事详情需要展开和收起的 */
export const SIZE_MARKET_OPTIONS = {
  [EMtype.Mty3042]: 30,
  [EMtype.Mty1186]: 20,
  [EMtype.Mty1111]: 10,
  1189: 10,
  1190: 10,
}

/** 得分语言 */
export const scoreLangKey = {
  5: t('EventScore'),
  6: t('EventCorner'),
  7: t('EventYellow'),
  8: t('EventRed'),
  9: t('EventBooking'),
  127: t('EventKill'),
  1551: t('EventHalfScore'),
  3551: t('EventFirstQuarterScore'),
  3552: t('EventSecondQuarterScore'),
  3553: t('EventThirdQuarterScore'),
  5556: t('EventGameScore'),
  5557: t('EventAce'),
  5558: t('EventDouble'),
  5559: t('GameSet'),
  12: t('FrameScor'),
  13: t('BreakScore'),
  14: t('Home-Run'),
  15: t('Hit'),
  16: t('Touchdown'),
  17: t('FieldGoal'),
  18: t('FieldGoal1'),
  19: t('Runs'),
  20: t('Fours'),
  21: t('Sixes'),
  22: t('Wicket'),
  23: t('Runs'),
  24: t('Fours'),
  25: t('Sixes'),
  26: t('Wicket'),
  27: t('LegScore'),
  28: t('180s'),
  29: t('Checkout'),
  30: t('Extra'),
  31: t('Extra1'),
  32: t('Extra2'),
  33: t('Extra3'),
}

/** 列数 */
export const marketTypeStyles = {
  1075: {
    row: 2,
  },
  1076: {
    row: 2,
  },
  1077: {
    row: 2,
  },
  164029: {
    row: 2,
  },
  164030: {
    row: 2,
  },
  165030: {
    row: 2,
  },
  165031: {
    row: 2,
  },
  169026: {
    row: 2,
  },
  169027: {
    row: 2,
  },
  179026: {
    row: 2,
  },
  179027: {
    row: 2,
  },
  1097: {
    row: 2,
  },
  1116: {
    row: 2,
  },
  1233: {
    row: 2,
  },
  1234: {
    row: 2,
  },
  1012: {
    row: 3,
  },
  1101: {
    row: 2,
  },
  1103: {
    row: 2,
  },
  7020: {
    row: 2,
  },
  1105: {
    row: 2,
  },
  177031: {
    row: 2,
  },
  1106: {
    row: 2,
  },
  177032: {
    row: 2,
  },
  1109: {
    row: 2,
  },
  1110: {
    row: 2,
  },
  1028: {
    row: 2,
  },
  1115: {
    row: 2,
  },
  177023: {
    row: 2,
  },
  1124: {
    row: 2,
  },
  164016: {
    row: 2,
  },
  164027: {
    row: 3,
  },
  164028: {
    row: 2,
  },
  164031: {
    row: 2,
  },
  164032: {
    row: 2,
  },
  164033: {
    row: 2,
  },
  165016: {
    row: 2,
  },
  165027: {
    row: 3,
  },
  165028: {
    row: 2,
  },
  165029: {
    row: 2,
  },
  165032: {
    row: 2,
  },
  165033: {
    row: 2,
  },
  180016: {
    row: 2,
  },
  180027: {
    row: 3,
  },
  180028: {
    row: 2,
  },
  180029: {
    row: 2,
  },
  180031: {
    row: 2,
  },
  180032: {
    row: 2,
  },
  180033: {
    row: 2,
  },
  169028: {
    row: 2,
  },
  169030: {
    row: 2,
  },
  169031: {
    row: 3,
  },
  179028: {
    row: 2,
  },
  179030: {
    row: 2,
  },
  179031: {
    row: 3,
  },
  177028: {
    row: 2,
  },
  1145: {
    row: 2,
  },
  1171: {
    row: 2,
  },
  1172: {
    row: 2,
  },
  1174: {
    row: 2,
  },
  1175: {
    row: 2,
  },
  1112: {
    row: 3,
  },
  1113: {
    row: 3,
  },
  1030: {
    row: 3,
  },
  177025: {
    row: 3,
  },
  1032: {
    row: 3,
  },
  177024: {
    row: 3,
  },
  1078: {
    row: 3,
  },
  177027: {
    row: 3,
  },
  1079: {
    row: 3,
  },
  177026: {
    row: 3,
  },
  1031: {
    row: 3,
  },
  1114: {
    row: 3,
  },
  1118: {
    row: 3,
  },
  1129: {
    row: 3,
  },
  1102: {
    row: 3,
  },
  1018: {
    row: 3,
  },
  // 169037: {
  //   row: 3
  // },
  1051: {
    row: 3,
  },
  1125: {
    row: 3,
  },
  1173: {
    row: 3,
  },
  1033: {
    row: 3,
  },
  177022: {
    row: 3,
  },
  177029: {
    row: 3,
  },
  1170: {
    row: 3,
  },
  // 冰球
  2008: {
    row: 3,
  },
  2014: {
    row: 2,
  },
  2015: {
    row: 3,
  },
  // 籃球
  3007: {
    row: 2,
  },
  3044: {
    row: 2,
  },
  3045: {
    row: 2,
  },
  3046: {
    row: 2,
  },
  169037: {
    row: 2,
  },
  179037: {
    row: 2,
  },
  3014: {
    row: 2,
  },
  3016: {
    row: 3,
  },
  3017: {
    row: 3,
  },
  3026: {
    row: 3,
  },
  3027: {
    row: 3,
  },
  3043: {
    row: 3,
  },
  3028: {
    row: 3,
  },
  3029: {
    row: 3,
  },
  3030: {
    row: 3,
  },
  3031: {
    row: 3,
  },
  3033: {
    row: 3,
  },
  3037: {
    row: 3,
  },
  3038: {
    row: 3,
  },
  3039: {
    row: 3,
  },
  3040: {
    row: 3,
  },
  3041: {
    row: 2,
  },
  // 網球
  5015: {
    row: 2,
  },
  // 美式足球
  6012: {
    row: 3,
  },
  6013: {
    row: 3,
  },
  6015: {
    row: 3,
  },
  6020: {
    row: 2,
  },
  // 棒球
  7010: {
    row: 3,
  },
  7019: {
    row: 2,
  },
  // 板球
  14016: {
    row: 3,
  },
  // MMA
  18004: {
    row: 3,
  },
  // 拳击
  19004: {
    row: 3,
  },
  // 电竞足球
  177012: {
    row: 3,
  },
  177014: {
    row: 2,
  },
  177015: {
    row: 2,
  },
  // 电竞篮球
  178009: {
    row: 2,
  },
  16021: {
    row: 3,
  },
  3042: {
    row: 3,
  },
  1186: {
    row: 2,
  },
  2018: {
    row: 3,
  },
  2020: {
    row: 3,
  },
  8010: {
    row: 3,
  },
  13013: {
    row: 2,
  },
  15014: {
    row: 2,
  },
}

// 波胆 排列 保留空位
export const bdMap = [
  1188,
  1192,
  1237,
]
